/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * @type {EntityState}
 */
export const entityState = {
    entity: {},
    schemas: {},
    Entity: {},
    EditorState: {},
    loading: false,
};

/**
 * @typedef {object} Entity
 * @property {string} type
 */

/**
 * @typedef {object} ModelState
 * @property {Entity} Entity
 * @property {EditorState} EditorState
 * @property {boolean} loading
 */
